import { createAction } from '@ngrx/store';

export const opetPartsBuyoutModal = createAction(
    '[PartsBuyout] Open Parts Buyout Modal'
);